import requirementsManager from './requirements.js'
import groupManager from './group4.js'
import { defaultPropertyConfig, status } from './common.js';
import combinationManager from './combination.js';
import { setPath, getPath, parse } from './path';
import validator from './veriflcation';
// const defaultProperty = {
//   isCombination: false, //是否餐品组合
//   combinationId: '', //餐品组合id
//   isScore: false, // 是否积分兑换餐品
//   title: '', // 商品名字
//   price: 0, // 商品价格
// }

// "products": [{
//     "uid": 2,
//     "brandId": 1,
//     "name": "珍珠",
//     "isNew": true,
//     "isSpecialty": true,
//     "isSpicy": false,
//     "isSideDish": false,
//     "price": 2,
//     "startPrice": 1,
//     "costPrice": 1,
//     "desc": "我1是1描述",
//     "logo": "",
//     "image": "",
//     "type": 1,
//     "isRequirement": false,
//     "propertyId": 0,
//     "property": {
//       "uid": 1,
//       "brandId": 1,
//       "name": "常规奶茶（益生菌）2",
//       "standard": {
//         "uid": 5,
//         "title": "奶茶",
//         "channelType": 3,
//         "type": 1,
//         "items": [{
//           "uid": 13,
//           "name": "中杯奶茶",
//           "price": 3
//         }, {
//           "uid": 14,
//           "name": "小杯奶茶",
//           "price": 2
//         }]
//       },
//       "propertys": [{
//         "uid": 6,
//         "title": "属性1",
//         "channelType": 3,
//         "type": 3,
//         "items": [{
//           "uid": 15,
//           "name": "加冰"
//         }]
//       }, {
//         "uid": 7,
//         "title": "属性2",
//         "channelType": 3,
//         "type": 3,
//         "items": [{
//           "uid": 16,
//           "name": "加辣"
//         }]
//       }],
//       "choices": {
//         "uid": 8,
//         "title": "多选11",
//         "channelType": 1,
//         "type": 2,
//         "items": [{
//           "uid": 17,
//           "name": "多选1",
//           "price": 4
//         }, {
//           "uid": 18,
//           "name": "多选2",
//           "price": 3
//         }]
//       },
//       "channelTypes": [
//         3,
//         1
//       ],
//       "status": 1,
//       "platformKey": "",
//       "createTime": "2018-01-23 16:19:49",
//       "createDate": "2018-01-23",
//       "updateTime": "2018-01-26 17:27:38",
//       "updateDate": "2018-01-26"
//     },
//     "mealFee": 1.5,
//     "isSoldOut": "false",
//     "hasStock": "true",
//     "stockNum": 3,
//     "isInServiceTime": "false",
//     "status": 2
//   }]

let total = 0;
let globalRule = {
  isSoldOut: [
    { type: 'boolean', value: true, message: '该餐品已售罄' }
  ],
  isInServiceTime: [
    { type: 'boolean', value: false, message: '不在营业时间' }
  ],
  hasInventory: [
    { 
      validator: (rule, value, source, callback) => {
        if (value) {
          if (source.hasInventory && source.inventoryNum === 0 || source.num > source.inventoryNum) {
            callback(new Error('该餐品库存不足'));
          } else {
            callback();
          }
        }
      }
    }
  ]
}

/**
  * 添加新的商品，初始化新的商品数据
  * @param food 商品参数
  * @param num 数量, 如果有则传入，默认为1
  * @param typeId 数量, 分类id
  * @param index 当前数组下标
*/
const addProperty = ({food = false, num = 1, typeId, index, group = false, combination = false, selectCombination = 0 }) => {
  let products, listRequirements, groups;
  // if (food === undefined && Object.keys(food).length === 0 && !food.uid && !typeId) {
  //   return status.params;
  // }
  if (food && !food.isCombination) {
    const rules = globalRule;
    const error = validator(rules, {
      isInServiceTime: food.isInServiceTime,
      isSoldOut: food.isSoldOut,
      hasInventory: food.hasInventory,
      inventoryNum: food.inventoryNum,
      num
    });
    if (error.length) {
      return {
        status: false,
        message: error[0]
      };
    }
    products = {
      pid: food.uid,
      typeId: typeId || food.smallTypeId || food.bigTypeId,
      num,
      isScore: food.isScore || false,
      title: food.name,
      titleEn: food.nameEn || food.name,
      price: food.price,
      remark: food.remark || '',
    };
    let _config = {};
    defaultPropertyConfig.forEach((key) => {
      if (food[key] !== undefined) {
        _config[key] = food[key];
      }
    });
    products._means = {
      getPath: '_products[' + index + ']',
      config: _config
    }
    // Object.defineProperty(products, '_means', {
    //   value: {
    //     getPath: 'products[' + index + ']',
    //     config: _config,
    //     getIndex: index
    //   }
    // });
    if (food.isRequirement && food.hasOwnProperty('requirements') && food.requirements.length) { // 如果有特殊要求
      listRequirements = [];
      listRequirements._means = {
        getPath: products._means.getPath + '.listRequirements',
        requirements: food.requirements
      }
      let req = requirementsManager.addRequirements(food.requirements, listRequirements, num);
      listRequirements.push(req);
    }
  } else if (combination) {
    products = combinationManager.addCombination(combination, selectCombination, index, num);
    if (!products.status) {
      return products;
    }
  }
  if (group) {
    groups = [];
    const data = groupManager.addGroups4(group, groups.length, num, products);
    if (data.status) {
      groups.push(data.data);
      Object.defineProperty(groups, '_group', {
        value: group
      });
    } else {
      return data;
    }
  }
  total += num;
  let propertys = { status: false };
  if (products !== undefined) {
    propertys.products = products;
    propertys.status = true;
    if (listRequirements !== undefined) {
      propertys.products.listRequirements = listRequirements;
    }
    if (groups !== undefined) {
      propertys.products.groups = groups;
    }
  }
  // propertys.data = new product(products, listRequirements, groups);
  return propertys;
}

/**
  * 改变obj对象的某个值
  * param obj {object} 要改变的对象
  * param item {object} 位于该对象里的某个对象
  * param newItem {object} 修改该对象的值使用Object.assign({}, item, newItem);合并
*/
const changeItem = (obj, item, newItem) => {
  if (!obj || !item || !newItem) {
    return false;
  }
  let changeObj = Object.assign({}, item.products || item, newItem);
  if (item._means !== undefined) {
    if (item._means.getPath) {
      const reg = /\[\d+\]$/; // 判断路径最后一个[]里面是否是数组
      if (reg.test(item._means.getPath)) { // 如果是数组
        // 获得当前index
        let doData = getPath(obj, item._means.getPath.replace(reg, ''));
        let indexStart = item._means.getPath.lastIndexOf('[');
        let indexEnd = item._means.getPath.lastIndexOf(']');
        let index = Number(item._means.getPath.slice(indexStart + 1, indexEnd));
        // const shadowData = doData;
        // shadowData[index] = changeObj;
        // doData = shadowData;
        doData.splice(index, 1, changeObj); // 修改当前数据
      } else {
        setPath(obj, item._means.getPath, changeObj); // 如果是对象则直接调用setPath修改
      }
    }
  }
}

/**
  * 为obj对象添加值
  * param obj {object} 要改变的对象
  * param item {object} 位于该对象里的某个对象
  * param newItem {object} 添加的新值
  * param key {string} 在item添加的新的对象字段名，如果不提供则替换item对象
*/
const setItem = (obj, item, newItem, key) => {
  if (!obj || !item || !newItem) {
    return false;
  }
  let keyTmp;
  if (key) {
    keyTmp = '.' + key;
  } else {
    keyTmp = ''
  }
  if (item._means !== undefined) {
    const _means = JSON.parse(JSON.stringify(item._means));
    const reg = /\[\d+\]$/;
    let source;
    if (item._means.getPath) {
      if (key) { // 如果key值不为空
        if (reg.test(keyTmp)) { // 判断一下keyTmp是否为数组对象
          let sourceKey = key.replace(reg, '');
          source = getPath(obj, _means.getPath); // 获取该对象
          source[sourceKey] = []; // 初始化该对象
          newItem._means = {
            getPath: _means.getPath.replace(reg, '') + '[' + source.length + ']'
          };
          source[sourceKey].push(newItem);
          return;
        } 
        source = getPath(obj, item._means.getPath + keyTmp);
        if (!source) { // 该对象是否不存在
          source = getPath(obj, _means.getPath); // 获取该对象
          source[key] = {};
          // source = getPath(obj, item._means.getPath + keyTmp); // 获取该对象
          newItem._means = {
            getPath: _means.getPath + keyTmp
          };
          source[key] = newItem;
          setPath(obj, _means.getPath + keyTmp, newItem);
        } else { // 如果存在
          newItem._means = {
            getPath: _means.getPath + keyTmp
          };
          if (_means.items) {
            newItem._means.items = _means.items;
          }
          setPath(obj, _means.getPath + keyTmp, newItem);
        }
      } else {
        if (!newItem._means) {
          newItem._means = {
            getPath: _means.getPath
          };
          if (_means.items) {
            newItem._means.items = _means.items;
          }
        }
        if (reg.test(_means.getPath)) { // 如果是数组
          source = getPath(obj, _means.getPath.replace(reg, '')); // 获取该对象
          let indexStart = _means.getPath.lastIndexOf('[');
          let indexEnd = _means.getPath.lastIndexOf(']');
          let index = Number(_means.getPath.slice(indexStart + 1, indexEnd));
          source.splice(index, 1, newItem); // 修改当前数据
        } else {
          setPath(obj, _means.getPath, newItem);
        }
      }
    }
  }
}

/**
  * 为obj对象删除值
  * param obj {object} 要改变的对象
  * param delObj {object} 位于该对象里的某个对象
*/
const delItem = (obj, delObj) => {
  if (!obj || !delObj || !delObj._means) {
    return false;
  }
  let path = delObj._means.getPath;
  const reg = /\[\d+\]$/;
  if (reg.test(path)) { // 如果是数组
    let doData = getPath(obj, path.replace(reg, ''));
    setPath(obj, path);
    for (let i = 0; i < doData.length; i ++) { // 更新path
      doData[i]._means.getPath = doData[i]._means.getPath.replace(reg, '') + '[' + i + ']';
      let pathNameArr = parse(doData[i]._means.getPath);
      changePath(doData[i], pathNameArr[pathNameArr.length - 2], `${pathNameArr[pathNameArr.length - 2]}[${i}]`);
    }
  } else {
    setPath(obj, path);
  }
}

/**
  * 递归修改子对象path的方法
  * param obj {object} 要改变的对象
  * param name {string} 要修改的路径名
*/
const changePath = (obj, name, repPath) => {
  const reg = new RegExp(name + '\\[\\d+\\]');
  const replacePath = (obj, value) => {
    if (obj._means && obj._means.getPath) {
      if (obj._means.getPath.indexOf(name) >= 0 && reg.test(obj._means.getPath) && obj._means.getPath.indexOf(value) < 0) {
        if (/^\d+$/.test(value)) {
          obj._means.getPath = obj._means.getPath.replace(reg, value);
        } else {
          obj._means.getPath = obj._means.getPath.replace(reg, value);
        }
      }
    }
  }
  if (Array.isArray(obj)) {
    for (let i = 0; i < obj.length; i ++) {
      if (typeof obj[i] === 'object') {
        if (obj[i]._means) {
          replacePath(obj[i], repPath);
        }
        changePath(obj[i], name, repPath);
      }
    }
  }
  if (typeof obj === 'object') {
    for (let key in obj) {
      if (typeof obj[key] === 'object') {
        if (key !== '_means' && obj[key]._means) {
          replacePath(obj[key], repPath);
        }
        if (key !== '_means') {
          changePath(obj[key], name, repPath);
        }
      }
    }
  }
}

/**
  * 为obj对象添加值
  * param obj {object} 要改变的对象
  * param item {object} 位于该对象里的某个对象
  * param newItem {object} 添加的新值
  * param key {string} 在item添加的新的对象字段名，如果不提供则替换item对象
*/
const addItem = (obj, item, newItem, key) => {
  if (!obj || !item || !newItem) {
    return false;
  }
  let keyTmp;
  if (key) {
    keyTmp = '.' + key;
  } else {
    keyTmp = ''
  }
  if (item._means !== undefined) {
    const _means = JSON.parse(JSON.stringify(item._means));
    const reg = /\[\d+\]$/;
    let source;
    if (item._means.getPath) {
      if (key) { // 如果key值不为空
        source = getPath(obj, item._means.getPath + keyTmp);
        if (!source) { // 该对象是否不存在
          if (reg.test(keyTmp)) { // 判断一下keyTmp是否为数组对象
            source = getPath(obj, _means.getPath); // 获取该对象
            source[key] = []; // 初始化该对象
            source = getPath(obj, _means.getPath + keyTmp); // 获取该对象
            newItem._means = {
              getPath: _means.getPath.replace(reg, '') + '[' + source.length + ']'
            };
            source.push(newItem);
          } else {
            source = getPath(obj, _means.getPath); // 获取该对象
            source[key] = {};
            // source = getPath(obj, item._means.getPath + keyTmp); // 获取该对象
            newItem._means = {
              getPath: _means.getPath + keyTmp
            };
            source[key] = newItem;
            setPath(obj, _means.getPath + keyTmp, newItem);
          }
        } else { // 如果存在
          if (Array.isArray(source)) { // 是否是数组
            if (!newItem._means) {
              newItem._means = {
                getPath: _means.getPath + keyTmp + '[' + source.length + ']'
              };
              if (_means.items) {
                newItem._means.items = _means.items;
              }
            }
            source.push(newItem);
          } else {
            if (!newItem._means) {
              newItem._means = {
                getPath: _means.getPath + keyTmp
              };
              if (_means.items) {
                newItem._means.items = _means.items;
              }
            }
            setPath(obj, _means.getPath + keyTmp, newItem);
          }
        }
      } else {
        if (reg.test(_means.getPath)) {
          source = getPath(obj, _means.getPath.replace(reg, ''));
          if (!newItem._means) {
            newItem._means = {
              getPath: _means.getPath.replace(reg, '') + '[' + source.length + ']'
            };
            if (_means.items) {
              newItem._means.items = _means.items;
            }
          }
          source.push(newItem);
        } else {
          source = getPath(obj, _means.getPath);
          if (!newItem._means) {
            newItem._means = {
              getPath: _means.getPath
            };
            if (_means.items) {
              newItem._means.items = _means.items;
            }
          }
          if (Array.isArray(source)) {
            source.push(newItem);
          } else {
            setPath(obj, _means.getPath, newItem);
          }
        }
      }
    }
  }
}
/**
  * 如果该套餐对象未初始化则递归改变该对象
*/
const changeGroupItem = (data) => {
  const reg = /_products\[\d+\]\.groups\[\d+\]/;
  if (Array.isArray(data)) {
    let lastIndex = 0;
    let numArr = data.map((item, itemIndex) => {
      if (item._means && reg.test(item._means.getPath)) {
        let index = + item._means.getPath.replace(/_products\[\d+\]\.groups\[/, '').charAt(0);
        let num = 0;
        num = index - 1;
        let numList = [];
        while(num !== 0 && num > lastIndex) {
          numList.push(num--);
        }
        lastIndex = index;
        return numList;
      }
      lastIndex = itemIndex;
      return [];
    });
    const deepFlatten = arr =>
      arr.reduce((a, v) => a.concat(Array.isArray(v) ? deepFlatten(v) : v), []);
    numArr = deepFlatten(numArr);
    return numArr;
  }
}

/**
  * 单个餐品的减运算
*/
const productsMinus = (products, num) => {
  if (!products && num > products.num) {
    return;
  }
  let minusNum = num;
  let requirements = products.listRequirements || products.listPropertys || [];
  let reqLength = requirements.length;
  if (reqLength) {
    while(minusNum !== 0) {
      if (requirements[reqLength - 1].num < minusNum) {
        minusNum = 0;
      } else {
        if (requirements[reqLength - 1].num > minusNum) {
          requirements[reqLength - 1].num -= pro.num;
          minusNum -= requirements[reqLength - 1].num;
        } else {
          let reqNum = requirements.pop().num;
          minusNum -= reqNum;
          reqLength = requirements.length;
        }
      }
    }
    products.num -= num;
  } else {
    products.num -= num;
  }
}

/**
  * 单个餐品的加运算
*/
// const productsPlus = (products, num) => {
//   if (!products) {
//     return;
//   }

// }


const reqChange = (obj, params) => { // 特殊要求变更判断
  const itemsType = { // 类型
    radio: 4,
    checkbox: 5,
    table: 3,
  }
  if (params.type === 'add') {
    let listPropertys = {};
    let num = params.oldObj.num || 1;
    let index = 0;
    let items = [];
    let property = false;
    let requirements = [];
    let callFun;
    let key = '';
    if (params.oldObj.listPropertys) { // 是否是套餐特殊要求对象
      key = 'listPropertys';
    } else if (params.oldObj.propertys) { // 是否是特殊要求对象
      key = 'propertys';
    } else if (params.oldObj.listRequirements) { // 是否是普通餐品特殊要求对象
      key = 'listRequirements';
    }
    if (!key && params.oldObj._means && params.oldObj._means.getPath.indexOf('listPropertys') >= 0) { // 是套餐的特殊要求
      params.obj = requirementsManager.computedAlterPrice(params.obj, params.obj.num);
      addItem(obj, params.oldObj, params.obj, params.key);
      return;
    }
    if (!key && params.oldObj._means.getPath.indexOf('listRequirements') >= 0 && params.oldObj._means.getPath.indexOf('propertys') < 0) { // 是单品的特殊要求
      key = 'listRequirements';
      requirements = params.oldObj._means.requirements;
      num = 1;
      params.oldObj = getPath(obj, params.oldObj._means.getPath.replace('.listRequirements', ''));
    } else if (!key && params.oldObj._means.getPath.indexOf('listRequirements') >= 0 && params.oldObj._means.getPath.indexOf('propertys') >= 0) { // 是单品特殊要求里面的propertys对象
      params.obj = requirementsManager.computedAlterPrice(params.obj, params.obj.num);
      addItem(obj, params.oldObj, params.obj, params.key);
      return;
    }
    if (key === 'listPropertys' && params.requirements) {
      requirements = params.requirements.requirements;
    }
    if (key === 'listPropertys' || key === 'listRequirements') { // 如果有是第一次添加
      if (params.oldObj[key].length === 0 && params.oldObj.num - params.oldObj[key].length > 1) {
        num = 1;
      }
      if (params.oldObj[key].length) {
        listPropertys = params.oldObj[key];
        index = listPropertys.length;
      } else {
        listPropertys = requirementsManager.addRequirements(
          params.requirements || requirements,
          params.oldObj[key],
          num,
          key === 'listPropertys' ? true : false
        );
        index = params.oldObj[key].length
      }
      callFun = () => {
        if (property && items.length && params.oldObj[key].length === 0) {
          listPropertys.propertys.push(property);
          let listData = [listPropertys];
          listData._means = JSON.parse(JSON.stringify(params.oldObj[key]._means));
          params.oldObj[key] = listData;
        }
      };
    } else if (key === 'propertys') { // 如果有特殊要求
      listPropertys = params.oldObj;
      index = params.oldObj[key].length;
      if (params.requirements && params.requirements.requirements) {
        requirements = params.requirements.requirements;
      } else if (params.oldObj._means && params.oldObj._means.requirements) {
        requirements = params.oldObj._means.requirements;
      } else if (params.requirements) {
        requirements = params.requirements;
      }
      callFun = () => {
        if (property && items.length) {
          listPropertys.propertys.push(property);
        }
      };
    }
    requirements.forEach((req) => {
      let findIndex = req.items.findIndex(item => { 
        for (let keys in item) {
          if (params.obj[keys] && item[keys] !== params.obj[keys]) {
            return false;
          }
        }
        return true;
      })
      if (findIndex >= 0) {
        items = requirementsManager.addItems(
          false,
          [params.obj],
          itemsType[itemsType],
          listPropertys._means.getPath + '.propertys[' + index + ']',
          num || 1
        );
        property = {
          _means: {
            getPath: listPropertys._means.getPath + '.propertys[' + index + ']',
            items: req.items
          },
          items,
          pid: req.uid
        }
      }
    })
    callFun && callFun();
  } else if (params.type === 'del') {
    delItem(obj, params.oldObj);
  } else if (params.type === 'change') {
    if (params.oldObj._means.getPath.indexOf('listPropertys') >= 0) {
      params.obj = requirementsManager.computedAlterPrice(params.obj, params.obj.num);
    }
    changeItem(obj, params.oldObj, params.obj);
  } else if (params.type === 'set') {
    if (params.oldObj._means.getPath.indexOf('listPropertys') >= 0) {
      params.obj = requirementsManager.computedAlterPrice(params.obj, params.obj.num);
    }
    setItem(obj, params.oldObj, params.obj, params.key);
  }
}

export {
  delItem,
  setItem,
  addItem,
  validator,
  reqChange,
  changeItem,
  addProperty,
  changeGroupItem,
  productsMinus,
  requirementsManager,
  groupManager,
  combinationManager,
  getPath
}

export default {
  delItem,
  setItem,
  addItem,
  validator,
  reqChange,
  changeItem,
  addProperty,
  changeGroupItem,
  productsMinus,
  requirementsManager,
  groupManager,
  combinationManager,
  getPath
}


// WEBPACK FOOTER //
// ./../../plugins/cart/property.js